class AnnouncementBarSlider extends HTMLElement {
  // connect component
  connectedCallback() {
    const slider = document.getElementById("announcementBarSlider");
    const sliderId = slider.id;
    let slideCount = slider.querySelectorAll(
      ".announcement-bar-slider--slide:not(.swiper-slide-duplicate)"
    ).length;
    if (slideCount > 1) {
      new Swiper(`#${sliderId}`, {
          clickable: true,
          navigation: {
              nextEl: `#${sliderId} .swiper-button-next`,
              prevEl: `#${sliderId} .swiper-button-prev`
          }
      });
    }
  }
}

customElements.define("announcement-bar-slider", AnnouncementBarSlider);
